
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component
export default class ConfirmPaymentRequestModal extends Vue {
  visible = false;

  loading = false;

  record: any = null;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  form: any = {
    po: '',
  };

  rules: any = {
    po: [
      { required: true, message: '请输入付款PO', trigger: 'blur' },
    ],
  };

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  open(record: any) {
    this.record = record || null;
    this.form = { po: (record && record.po) || '' };
    this.visible = true;
    this.$nextTick(() => {
      this.ruleForm && this.ruleForm.clearValidate('');
    });
  }

  handleOk() {
    this.ruleForm.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      this.loading = true;
      const res = await this.supplyService.postPlatSavePo({
        batch_no: this.record.batchNo,
        po: this.form.po,
      });
      this.loading = false;
      if (res) {
        this.$message.success('确认请款完成');
        this.onClose();
        this.$emit('refresh');
      }
    });
  }

  onClose() {
    this.visible = false;
    this.record = null;
    this.form = { po: '' };
    if (this.ruleForm) {
      this.ruleForm.resetFields();
    }
  }
}
